import { Send } from "lucide-react";

export default function SendProgress({ label = "Nachricht", detail = "" }) {
  return <div data-send-feedback role="status" aria-live="polite" className="flex flex-col items-center px-2 py-6 text-center">
              <div className="relative flex h-16 w-16 items-center justify-center">
                <span className="absolute inset-0 rounded-full border-2 border-[#0071E3]/25 border-t-[#0071E3] animate-spin" />
                <Send className="h-6 w-6 text-[#0071E3]" aria-hidden="true" />
              </div>
              <p className="mt-5 text-base font-semibold text-[#1D1D1F]">{label} wird gesendet</p>
              {detail ? <p className="mt-1 text-sm text-[#86868B]">{detail}</p> : null}
  </div>;
}
